module.exports = __webpack_public_path__ + "img/logo-header.29a35125.png";